// extracted by mini-css-extract-plugin
module.exports = {"root":"az_sg","marginNormal":"az_tg","marginDense":"az_ug","fullWidth":"az_vg"};